var map = {
	"./arrow.svg": [
		7190,
		190
	],
	"./assets.svg": [
		836,
		836
	],
	"./clients.svg": [
		3257,
		257
	],
	"./customer.svg": [
		7511,
		511
	],
	"./customerConfig.svg": [
		7773,
		773
	],
	"./dashboard.svg": [
		7461,
		461
	],
	"./drivers.svg": [
		1984,
		984
	],
	"./fileExport.svg": [
		6479,
		479
	],
	"./finance.svg": [
		8475,
		475
	],
	"./home.svg": [
		4174,
		174
	],
	"./hr.svg": [
		3865,
		865
	],
	"./job.svg": [
		2792,
		411
	],
	"./logo-small.svg": [
		8664,
		283
	],
	"./logo.svg": [
		6962,
		962
	],
	"./maintenance.svg": [
		4943,
		324
	],
	"./onboarding.svg": [
		7860,
		860
	],
	"./planner.svg": [
		4789,
		789
	],
	"./report.svg": [
		7501,
		501
	],
	"./subcontractor.svg": [
		8178,
		178
	],
	"./supplier-logo.svg": [
		7941,
		941
	],
	"./task.svg": [
		243,
		624
	],
	"./vehicles.svg": [
		5664,
		664
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4913;
module.exports = webpackAsyncContext;